import React from 'react';

/**
 * SettingsData - Data management tab component
 * Contains: export data button, database statistics
 */
const SettingsData = ({
  dbStats,
  onExportData,
  loading
}) => {
  return (
    <div className="settings-section compact">
      <div className="section-header">
        <h2>Data Management</h2>
      </div>

      <div className="data-management-content">
        <div className="data-card">
          <div className="data-card-icon">💾</div>
          <div className="data-card-content">
            <h3>Export Data</h3>
            <p>Download backup of all data</p>
            <button className="export-data-btn" onClick={onExportData} disabled={loading}>
              {loading ? 'Exporting...' : 'Download'}
            </button>
          </div>
        </div>

        <div className="data-card">
          <div className="data-card-icon">📊</div>
          <div className="data-card-content">
            <h3>Statistics</h3>
            <div className="stats-list">
              <div className="stat-item">
                <span className="stat-label">Items:</span>
                <span className="stat-value">{dbStats.totalItems}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Pallets:</span>
                <span className="stat-value">{dbStats.totalPallets}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Shipments:</span>
                <span className="stat-value">{dbStats.totalShipments}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsData;
